import FiltersDTO from "../DTO/training-filterDTO"
import {FILTERS_ARGS, LAYOUT_OPTIONS, LICENSE_TYPES_OPTIONS} from "../training-const"

export default class QuestionsFiltersModel {
  constructor(filters) {
    this.filters = new FiltersDTO(filters)
    this.options = {
      categories: {
        loading: false,
        list: []
      },
      layouts: {
        loading: false,
        list: LAYOUT_OPTIONS
      },
      license_types: {
        loading: false,
        list: LICENSE_TYPES_OPTIONS
      }
    }
  }

  async loadFilterOptions(store) {
    this.setQuestionCategories(store)
  }

  getApiData() {
    return {
      [FILTERS_ARGS.SEARCH]: this.filters.search && this.filters.search.length ? this.filters.search : undefined,
      [FILTERS_ARGS.CATEGORY]: this.filters.category,
      [FILTERS_ARGS.LAYOUT]: this.filters.layout,
      [FILTERS_ARGS.TYPE]: this.filters.type && this.filters.type.length ? this.filters.type : undefined,
      [FILTERS_ARGS.LICENSE_TYPE]: this.filters.license_type,
    }
  }

  async setQuestionCategories(store) {
    this.options.categories.loading = true
    let categories = await store.dispatch(`trainingCategories/list`, {cache: true})
    this.options.categories.list = categories;
    this.options.categories.loading = false
  }
}